import { render, staticRenderFns } from "./Noeyez.vue?vue&type=template&id=67828e1b&"
import script from "./Noeyez.vue?vue&type=script&lang=js&"
export * from "./Noeyez.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports